module.exports = __webpack_public_path__ + "static/media/Timer 9.4fe8c8dc.png";